export function isUserInIsrael(): boolean {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const israelTimezones = ["Asia/Jerusalem", "Asia/Hebron", "Asia/Gaza"];
  return israelTimezones.includes(timezone);
}
